import React, { Component } from "react"
import { Accordion, Button, Card, FormControl, ListGroup, Modal, OverlayTrigger, Popover, Tooltip } from "react-bootstrap"
import MsalAuth from "src/utilities/msalAuth"
import UserSettings from "src/utilities/UserSettings"
import reggie from "../../../../../../utilities/Reggie"
import EmployeeDataTypes from "../../../../Types/EmployeeTypes"
import ReferenceTypes from "../../../../Types/ReferenceTypes"
import MailingAddress from "./EditAddress/MailingAddress"
import PhysicalAddress from "./EditAddress/PhysicalAddress"
import EmergencyContacts from "./EmergencyContacts/EmergencyContacts"

interface EmployeeInfoProps {
    employee: EmployeeDataTypes
    userId: number | string
    reference: ReferenceTypes | any
    copy: EmployeeDataTypes
    loading: boolean
    countMissing: Function
    handleChange: Function | any
    appendParams: Function
    setEventType: Function
    copyToClipboard: Function
    singleDetail?: string
    readOnly: boolean
}

type EmployeeInfoTypes = {
    hoveredEmergencyContact: any
    editMailingAddress: boolean
    editPhysicalAddress: boolean
    confirmSetAddressesSame: boolean
    editingEmergencyContacts: boolean,
}

class EmployeeInfo extends Component<EmployeeInfoProps, EmployeeInfoTypes> {

    settings = MsalAuth.UserSettings() || { UserAdminEmployeeInfoOpen: true }

    state = {
        hoveredEmergencyContact: { EmergencyContactName: "", EmergencyContactPhone: "" },
        editMailingAddress: false,
        editPhysicalAddress: false,
        confirmSetAddressesSame: false,
        editingEmergencyContacts: false,
    }

    updateUserSettings = () => {
        let settings = MsalAuth.UserSettings() || {}
        settings.UserAdminEmployeeInfoOpen = !this.settings.UserAdminEmployeeInfoOpen
        UserSettings.update(settings)
    }

    emergencyContactHover = (contact: any) => {
        this.setState({ hoveredEmergencyContact: contact })
    }

    toggleEmergencyContactEdit = (args?: string) => {
        if (args && args === "off") {
            this.setState({ editingEmergencyContacts: false })
        } else {
            if (this.state.editingEmergencyContacts) {
                this.setState({ editingEmergencyContacts: false })
            } else {
                this.setState({ editingEmergencyContacts: true })
            }
        }
    }

    addressesMatch = () => {
        let employee = this.props.employee
        let a = JSON.stringify({ a: employee.Address1, b: employee.Address2, c: employee.City, d: employee.State, e: employee.ZipCode })
        let b = JSON.stringify({ a: employee.MailingAddress1, b: employee.MailingAddress2, c: employee.MailingCity, d: employee.MailingState, e: employee.MailingZipCode })
        if (a === b) {
            return true
        }
        return
    }

    setMailingSameAsPhysical = () => {
        let employee = this.props.employee
        this.props.appendParams([{ MailingAddress1: employee.Address1 }, { MailingAddress2: employee.Address2 }, { MailingCity: employee.City }, { MailingState: employee.State }, { MailingZipCode: employee.ZipCode }])
        this.setState({ confirmSetAddressesSame: false })
    }

    toggleModal = (key: string) => {
        let state: any = this.state
        if (!state[key]) {
            state[key] = true
        } else {
            state[key] = false
        }
        this.setState(state)
    }

    render() {

        let employee = this.props.employee
        let singleDetail = false
        if (this.props.singleDetail) {
            singleDetail = true
        }
        const readOnly = this.props.readOnly
        // const open = this.settings.UserAdminEmployeeInfoOpen

        const MissingEmpInfoPopover = (
            <Popover id="popover-basic">
                <Popover.Title as="h2">Please check the following fields:</Popover.Title>
                {this.props.countMissing(["FirstName", "LastName", "Address1", "City", "State", "ZipCode"]).map((item: string, index: number) =>
                    <div className="uac-missing-info-tooltip-text" key={`miss-emp-${index}`}>
                        <p className="uac-missing-info-tooltip-text-item-number">{`${index + 1}. `}</p>
                        <p className="uac-missing-info-tooltip-text-item">{item.replace(/([A-Z])/g, ' $1').trim()}</p>
                    </div>
                )}
            </Popover>
        )

        const MiddleInitialTooltip = (
            <Tooltip id="uac-tool-tip">
                One Character Please
            </Tooltip>
        )

        const effectiveDateTooltip = (
            <Tooltip id="uac-tool-tip">
                Edit
            </Tooltip>
        )

        const CopyToClipboardPopover = (
            <Tooltip id="uac-tool-tip">
                Copy to clipboard
            </Tooltip>
        )

        const EditEmergencyContactPopover = (
            <Tooltip id="uac-tool-tip">
                {/* {!readOnly && <div id="edit-emercency-contacts-popover">
                    <span className="material-icons">edit</span>
                    <p>Click to Edit</p>
                </div>}
                {readOnly && <div id="edit-emercency-contacts-popover">
                    <span id="cant-edit-emergency-contacts-icon" className="material-icons">emergency</span>
                </div>} */}
                <div id="edit-emercency-contacts-popover">
                    <span className="material-icons">edit</span>
                    <p>Click to Edit</p>
                </div>
            </Tooltip>
        )

        const CopyPhoneNumberPopover = (
            <Tooltip id="uac-tool-tip">
                {this.state.hoveredEmergencyContact &&
                    <div id="emergency-contact-tooltip">
                        <div id="emergency-contact-tooltip-name">
                            <span className="material-icons">person</span>
                            <p>{this.state.hoveredEmergencyContact.EmergencyContactName}</p>
                        </div>
                        <div id="emergency-contact-tooltip-phone">
                            <span className="material-icons">phone</span>
                            <p>{reggie.formatPhone(this.state.hoveredEmergencyContact.EmergencyContactPhone) || "*Invalid*"}</p>
                        </div>
                    </div>}
            </Tooltip>
        )

        return (

            <div className="UserAdminR1">
                {/* <Accordion defaultActiveKey={open ? "0" : "1"} id="user-admin-accordion" */}
                <Accordion defaultActiveKey="0" id="user-admin-accordion"
                    onClick={() => this.updateUserSettings()}
                >
                    <Card id="user-admin-card">
                        <Accordion.Toggle as={Card.Header} eventKey="0" >
                            {this.props.loading && <div id="user-admin-card-title">
                                <p>Employee Information</p>
                            </div>}
                            {!this.props.loading && this.props.countMissing(["FirstName", "LastName", "Address1", "City", "State", "ZipCode"]).length === 0 && <div id="user-admin-card-title">
                                <p>Employee Information</p>
                            </div>}
                            {!this.props.loading && this.props.countMissing(["FirstName", "LastName", "Address1", "City", "State", "ZipCode"]).length > 0 && <div id="user-admin-card-title-warning">
                                <p>Employee Information</p>
                                <OverlayTrigger delay={{ show: 50, hide: 400 }} placement="right" overlay={MissingEmpInfoPopover}>
                                    <div id="user-admin-card-title-warning-text">
                                        {!readOnly && <span className="material-icons">warning</span>}
                                        <p>({this.props.countMissing(["FirstName", "LastName", "Address1", "City", "State", "ZipCode"]).length})</p>
                                    </div>
                                </OverlayTrigger>
                            </div>}
                        </Accordion.Toggle>
                        <Accordion.Collapse eventKey="0">
                            <div id="uac-employee-info">
                                <div id="uac-employee-info-r1">
                                    <div className="FindField" id="uac-employee-info-r1-c1">
                                        <div id="uac-employee-info-fname">
                                            {employee.FirstName && <div id="uac-filled-field"><p>First Name{!readOnly && <span className="material-icons">done</span>}</p></div>}
                                            {!employee.FirstName && <div id="uac-missing-field"><p>First Name{!readOnly && <span className="material-icons">warning</span>}</p></div>}
                                            <FormControl onFocus={() => this.props.setEventType("FirstName")}
                                                disabled={this.props.loading || singleDetail || readOnly}
                                                placeholder={employee.FirstName || "*NA*"}
                                                aria-describedby="basic-addon1"
                                                onChange={this.props.handleChange}
                                                value={employee.FirstName || ""}
                                            />
                                        </div>
                                    </div>
                                    <div id="uac-employee-info-r1-c2">
                                        <div className="FindField" id="uac-employee-info-mi">
                                            {(!employee.MiddleName || employee.MiddleName.length === 1) && <div id="uac-filled-field"><p>Middle Initial</p></div>}
                                            {employee.MiddleName && employee.MiddleName.length > 1 &&
                                                <OverlayTrigger delay={{ show: 50, hide: 400 }} placement="top" overlay={MiddleInitialTooltip}>
                                                    <div id="uac-missing-field"><p>Middle Initial{!readOnly && <span className="material-icons">warning</span>}</p></div>
                                                </OverlayTrigger>}
                                            <FormControl onFocus={() => this.props.setEventType("MiddleName")}
                                                disabled={this.props.loading || singleDetail || readOnly}
                                                placeholder={employee.MiddleName || "*NA*"}
                                                aria-describedby="basic-addon1"
                                                onChange={this.props.handleChange}
                                                value={employee.MiddleName || ""}
                                            />
                                        </div>
                                    </div>
                                    <div id="uac-employee-info-r1-c3">
                                        <div className="FindField" id="uac-employee-info-lname">
                                            {employee.LastName && <div id="uac-filled-field"><p>Last Name{!readOnly && <span className="material-icons">done</span>}</p></div>}
                                            {!employee.LastName && <div id="uac-missing-field"><p>Last Name{!readOnly && <span className="material-icons">warning</span>}</p></div>}
                                            <FormControl onFocus={() => this.props.setEventType("LastName")}
                                                disabled={this.props.loading || singleDetail || readOnly}
                                                placeholder={employee.LastName || "*NA*"}
                                                aria-describedby="basic-addon1"
                                                onChange={this.props.handleChange}
                                                value={employee.LastName || ""}
                                            />
                                        </div>
                                    </div>
                                    <div id="uac-employee-info-r1-c4">
                                        <div className="FindField" id="uac-employee-info-pname">
                                            <div id="uac-filled-field"><p>Preffered Name</p></div>
                                            <FormControl onFocus={() => this.props.setEventType("PreferredName")}
                                                disabled={this.props.loading || singleDetail || readOnly}
                                                placeholder={employee.PreferredName || "*NA*"}
                                                aria-describedby="basic-addon1"
                                                onChange={this.props.handleChange}
                                                value={employee.PreferredName || ""}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div id="uac-employee-info-r4">
                                    <div className="FindField" id="uac-employee-info-physical-address">
                                        <div className="UACEditAddressHeader">
                                            {this.props.countMissing(["Address1", "City", "State", "ZipCode"]).length === 0 && <div id="uac-filled-field"><p>Physical Address{!readOnly && <span className="material-icons">done</span>}</p></div>}
                                            {this.props.countMissing(["Address1", "City", "State", "ZipCode"]).length > 0 && <div id="uac-missing-field"><p>Physical Address{!readOnly && <span className="material-icons">warning</span>}</p></div>}
                                            {!this.props.loading && <div className="UACEditAddressControls">
                                                <div className="UACEditAddressHeaderRight">
                                                    {!readOnly && <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={effectiveDateTooltip}>
                                                        <span id="uac-edit-address-btn" className="material-icons" onClick={() => this.toggleModal("editPhysicalAddress")}>create</span>
                                                    </OverlayTrigger>}
                                                    <OverlayTrigger delay={{ show: 50, hide: 0 }} placement="top" overlay={CopyToClipboardPopover}>
                                                        <span id="uac-copy-address-btn" className="material-icons" onClick={() => this.props.copyToClipboard(reggie.cleanLines(`${employee.Address1 || ""}\n${employee.Address2 || ""}\n${employee.City || ""} ${employee.State || ""} ${employee.ZipCode || ""}`), "Physical address")}>content_copy</span>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>}
                                        </div>
                                        <Card>
                                            <ListGroup id="edit-physical-address-list-group" onClick={() => this.toggleModal("editPhysicalAddress")}>
                                                <ListGroup.Item>{employee.Address1 || "*NA*"}</ListGroup.Item>
                                                {(employee.Address2 && employee.Address2.trim() !== "") && <ListGroup.Item>{employee.Address2 || ""}</ListGroup.Item>}
                                                {(employee.City && employee.State && employee.ZipCode) && <ListGroup.Item>{`${employee.City}, ${employee.State} ${employee.ZipCode || ""}`}</ListGroup.Item>}
                                                {(!employee.City || !employee.State || !employee.ZipCode) && <ListGroup.Item>{`${(employee.City || "")} ${(employee.State || "")} ${(employee.ZipCode || "")}`}</ListGroup.Item>}
                                            </ListGroup>
                                        </Card>
                                    </div>
                                    <div className="FindField" id="uac-employee-info-mailing-address">
                                        <div className="UACEditAddressHeader">
                                            {!this.addressesMatch() && <div className="UACEditAddressHeaderLeft">
                                                <div className="MailingAddressHeader"><p>Mailing Address</p>
                                                    {!this.props.loading && !readOnly && employee.Address1 && <p id="uac-set-same-as-physical-address-btn" onClick={() => this.toggleModal("confirmSetAddressesSame")}>Set same as Physical</p>}
                                                </div>
                                            </div>}
                                            {this.addressesMatch() && <div className="UACEditAddressHeaderLeft">
                                                <div className="MailingAddressHeader"><p>Mailing Address</p>
                                                    {!this.props.loading && <p id="mailing-address-same-as-physical-marker">(Same as Physical)</p>}
                                                </div>
                                            </div>}
                                            {!this.props.loading && <div className="UACEditAddressControls">
                                                <div className="UACEditAddressHeaderRight">
                                                    {!readOnly && <OverlayTrigger delay={{ show: 250, hide: 400 }} placement="top" overlay={effectiveDateTooltip}>
                                                        <span id="uac-edit-address-btn" className="material-icons" onClick={() => this.toggleModal("editMailingAddress")}>create</span>
                                                    </OverlayTrigger>}
                                                    <OverlayTrigger delay={{ show: 50, hide: 0 }} placement="top" overlay={CopyToClipboardPopover}>
                                                        <span id="uac-copy-address-btn" className="material-icons" onClick={() => this.props.copyToClipboard(reggie.cleanLines(`${employee.MailingAddress1 || ""}\n${employee.MailingAddress2 || ""}\n${employee.MailingCity || ""} ${employee.MailingState || ""} ${employee.MailingZipCode || ""}`), "Mailing address")}>content_copy</span>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>}
                                        </div>
                                        <Card>
                                            <ListGroup id="edit-mailing-address-list-group" onClick={() => this.toggleModal("editMailingAddress")}>
                                                <ListGroup.Item>{employee.MailingAddress1 || "*NA*"}</ListGroup.Item>
                                                {(employee.MailingAddress2 && employee.MailingAddress2.trim() !== "") && <ListGroup.Item>{employee.MailingAddress2}</ListGroup.Item>}
                                                {(employee.MailingCity && employee.MailingState && employee.MailingZipCode) && <ListGroup.Item > {`${employee.MailingCity}, ${employee.MailingState} ${employee.MailingZipCode || ""}`}</ListGroup.Item>}
                                                {(!employee.MailingCity || !employee.MailingState || !employee.MailingZipCode) && <ListGroup.Item>{`${(employee.MailingCity || "")} ${(employee.MailingState || "")} ${(employee.MailingZipCode || "")}`}</ListGroup.Item>}
                                            </ListGroup>
                                        </Card>
                                    </div>
                                </div>
                                <div id="uac-employee-info-r5">
                                    <div id="uac-employee-info-r5-c1">
                                        {!this.props.loading && !singleDetail && !readOnly && <OverlayTrigger delay={{ show: 50, hide: 0 }} placement="top" overlay={EditEmergencyContactPopover}>
                                            <div id="uac-emergency-contacts-btn" onClick={() => this.toggleModal("editingEmergencyContacts")}>
                                                <p>Emergency Contacts</p>
                                            </div>
                                        </OverlayTrigger>}
                                        {!this.props.loading && (singleDetail || readOnly) && <div id="uac-emergency-contacts-btn">
                                            <p>Emergency Contacts</p>
                                        </div>}
                                        <div id="uac-emergency-contacts-list">
                                            {employee.EmergencyContacts && employee.EmergencyContacts.slice(0, 3).map((contact: any, index: number) =>
                                                <div className="UACEmergencyContactItemWrapper" key={`contact-item-${index}`}>
                                                    {contact.EmergencyContactName && <OverlayTrigger delay={{ show: 50, hide: 0 }} placement="top" overlay={CopyPhoneNumberPopover}>
                                                        <div className="UACEmergencyContactItem"
                                                            onMouseEnter={() => this.emergencyContactHover(contact)}
                                                            onClick={() => this.props.copyToClipboard(reggie.formatPhone(contact.EmergencyContactPhone), "Number")}>
                                                            <span className="material-icons">call</span>
                                                            <p>{contact.EmergencyContactName}</p>
                                                        </div>
                                                    </OverlayTrigger>}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Accordion.Collapse>
                    </Card>
                </Accordion>
                {
                    this.state.editingEmergencyContacts &&
                    <EmergencyContacts
                        employee={employee}
                        userId={this.props.userId}
                        toggleEdit={this.toggleEmergencyContactEdit}
                        appendParams={this.props.appendParams}
                    />
                }
                {
                    this.state.editPhysicalAddress &&
                    <PhysicalAddress
                        employee={employee}
                        copy={this.props.copy}
                        appendParams={this.props.appendParams}
                        reference={this.props.reference}
                        toggleEditAddress={this.toggleModal}
                    />
                }
                {
                    this.state.editMailingAddress &&
                    <MailingAddress
                        employee={employee}
                        copy={this.props.copy}
                        appendParams={this.props.appendParams}
                        reference={this.props.reference}
                        toggleEditAddress={this.toggleModal}
                    />
                }
                {
                    this.state.confirmSetAddressesSame &&
                    <Modal
                        show={true}
                        backdrop="static"
                        keyboard={true}
                        centered={true}
                    >
                        <Modal.Header>
                            <div className="ConfirmSetAddresesSameModalHeader">
                                <p>Set Mailing Address same as Physical?</p>
                            </div>
                        </Modal.Header>
                        <Modal.Body>
                            <div className="ConfirmSetAddresesSameModalBody">
                                <div className="ConfirmSetAddresesSameModalBodyLeft">
                                    <div className="ConfirmSetAddresesSameModalBodyLeftHeader">
                                        <p>Mailing</p>
                                    </div>
                                    {employee.MailingAddress1 && <p>{employee.MailingAddress1}</p>}
                                    {employee.MailingAddress2 && <p>{employee.MailingAddress2}</p>}
                                    <div className="ConfirmSetAddresesSameModalBodyAddressLower">
                                        {employee.MailingCity && <p>{employee.MailingCity}</p>}
                                        {employee.MailingState && <p>{employee.MailingState}</p>}
                                        {employee.MailingZipCode && <p>{employee.MailingZipCode}</p>}
                                    </div>
                                </div>
                                <div className="ConfirmSetAddresesSameModalBodyMiddle">
                                    <span className="material-icons">arrow_forward</span>
                                </div>
                                <div className="ConfirmSetAddresesSameModalBodyRight">
                                    <div className="ConfirmSetAddresesSameModalBodyRightHeader">
                                        <p>Physical</p>
                                    </div>
                                    {employee.Address1 && <p>{employee.Address1}</p>}
                                    {employee.Address2 && <p>{employee.Address2}</p>}
                                    <div className="ConfirmSetAddresesSameModalBodyAddressLower">
                                        {employee.City && <p>{employee.City}</p>}
                                        {employee.State && <p>{employee.State}</p>}
                                        {employee.ZipCode && <p>{employee.ZipCode}</p>}
                                    </div>
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div className="ConfirmSetAddresesSameModalFooter">
                                <Button variant="secondary" onClick={() => this.toggleModal("confirmSetAddressesSame")}>Cancel</Button>
                                <Button variant="primary" onClick={() => this.setMailingSameAsPhysical()}>Yes</Button>
                            </div>
                        </Modal.Footer>
                    </Modal>
                }
            </div >
        )
    }
}

export default EmployeeInfo